import { useMemo } from 'react';

import type { User } from '@/interfaces/app.interfaces';

import { AppUtils } from '@/utils/app.utils';
import { ROLES } from '@/constants/roles';

import CompanyDetailsActionBar from '../../action-bar/CompanyDetailsActionBar';
import { NoCompanySelectedPanel, CompanySelectedPanel } from '../../panels';

import useSettingsStore from '../../../store/useSettingsStore';

import * as styles from './CompanyDetailsTab.css';

type Props = {
  user: User;
};

export default function CompanyDetailsTab({ user }: Props) {
  const selectedCompany = useSettingsStore((state) => state.selectedCompany);
  const activeCompany = AppUtils.getActiveCompany(user);

  const companyId = useMemo(() => {
    if (user.role === ROLES.MOEVE_ADMIN || user.role === ROLES.MANAGER) {
      return selectedCompany?.id;
    }
    return activeCompany?.company?.id;
  }, [user.role, selectedCompany?.id, activeCompany?.company?.id]);

  return (
    <div className={styles.root}>
      <CompanyDetailsActionBar user={user} />
      {!companyId ? <NoCompanySelectedPanel /> : <CompanySelectedPanel companyId={companyId} />}
    </div>
  );
}
